import React from 'react';
import { Navigate } from 'react-router-dom';
import sessionManager from '../utils/sessionManager';

// Route protection for admin dashboard
export const AdminRoute = ({ children }) => {
  if (!sessionManager.isAdminLoggedIn()) {
    return <Navigate to="/admin-login" replace />;
  }
  return children;
};

// Route protection for user dashboard
export const UserRoute = ({ children }) => {
  if (!sessionManager.isUserLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Route protection for tutor dashboard
export const TutorRoute = ({ children }) => {
  const tutorSession = localStorage.getItem('tutorSession');
  if (!tutorSession) {
    return <Navigate to="/tutor-login" replace />;
  }
  
  try {
    const session = JSON.parse(tutorSession);
    if (session.status !== 'approved') {
      return <Navigate to="/tutor-login" replace />;
    }
  } catch (error) {
    return <Navigate to="/tutor-login" replace />;
  }
  
  return children;
};

// Route protection for login pages
export const PublicRoute = ({ children, type }) => {
  if (type === 'admin' && sessionManager.isAdminLoggedIn()) {
    return <Navigate to="/admin-dashboard" replace />;
  }
  if (type === 'user' && sessionManager.isUserLoggedIn()) {
    // Additional check to ensure the session is valid and has user data
    const currentSession = sessionManager.getCurrentSession();
    if (currentSession && currentSession.userData && currentSession.userType === '2') {
      return <Navigate to="/dashboard" replace />;
    } else {
      // Clear invalid session
      sessionManager.logoutCurrentUser();
    }
  }
  if (type === 'tutor') {
    // Check if tutor is already logged in
    const tutorSession = localStorage.getItem('tutorSession');
    if (tutorSession) {
      try {
        const session = JSON.parse(tutorSession);
        if (session.status === 'approved') {
          // Don't redirect to dashboard automatically - let the user choose
          // The tutor dashboard will handle the case if profile doesn't exist
          return <Navigate to="/tutor-dashboard" replace />;
        }
      } catch (error) {
        // Clear corrupted session
        localStorage.removeItem('tutorSession');
      }
    }
  }
  return children;
};

